import React, { useState } from "react";
import { FaGoogle } from "react-icons/fa";
import API from '../../utils/api';
import { useNavigate } from "react-router-dom";
import { HiArrowRight } from "react-icons/hi";
const HowRemove = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async () => {
    if (!query.trim()) return;

    try {
      setLoading(true);

      const res = await API.post("/google/search", {
        textQuery: query,
      });

      if (res.status === 200 && res.data) {
        navigate("/Bewertungsmanager-1", {
          state: {
            places: res.data,
          },
        });

      }
    } catch (err) {
      console.log("API Error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  return (
    <section className="relative  bg-cover bg-no-repeat font-sans  py-4 md:py-8 px-4">

      {/* TOP SECTION: Heading + Subtitle */}

      <div className="flex flex-col gap-3 mb-10 mt-10 items-center text-center">
        <h2 className="h2-mb h2-md h2-lg h2-2xl">
          Unfaire Bewertung(en)?   <br />
          <span className="text-[#0b2b40]">Wie Sie die Löschung einleiten:</span>
        </h2>
        <p className="text-gray-500 text-sm md:text-lg w-11/12 md:w-1/2 mt-4 text-center">
          Unser Bewertungsmanager gibt Ihnen die Kontrolle über Ihren Ruf zurück - ganz risikofrei, denn Sie zahlen nur bei erfolgreicher Löschung.
        </p>
      </div>


      {/* STEPS DESKTOP */}
      <div className="hidden lg:flex justify-center mt-12 gap-10 items-center">
        <StepCircle active={currentStep === 1} number="1" text="Firmenname eingeben" />
        <StepLine active={currentStep > 1} />

        <StepCircle active={currentStep === 2} number="2" text="Negative Bewertung auswählen" />
        <StepLine active={currentStep > 2} />

        <StepCircle active={currentStep === 3} number="3" text="Vorgang starten" />
      </div>

      {/* STEPS MOBILE */}
      <div className="lg:hidden flex justify-center mt-10 gap-6">
        <StepCircle active={currentStep === 1} number="1" text="Firmenname eingeben" />
        <StepLine active={currentStep > 1} />

        <StepCircle active={currentStep === 2} number="2" text="Negative Bewertung auswählen" />
        <StepLine active={currentStep > 2} />

        <StepCircle active={currentStep === 3} number="3" text="Vorgang starten" />
      </div>

      {/* FORM CARD */}

      <div className="flex justify-center mt-14">
        <div className="bg-white w-full max-w-[820px] rounded-2xl border border-gray-300 shadow-lg p-2 lg:p-10 flex flex-col gap-6">

          <h3 className="h3-mb h3-md h3-lg h3-2xl text-center">
            Ihr Unternehmen finden

          </h3>

          {/* GRADIENT BORDER WRAPPER */}
          <div className="p-[4px] bg-gradient-to-b from-[#0b2b40] to-transparent rounded-2xl">
            <div className="bg-gradient-to-b from-[#D1EFEC] via-white to-transparent rounded-xl p-6 flex flex-col gap-4">

              {/* SEARCH INPUT */}
              <div className="bg-white relative flex items-center gap-3 rounded-full px-5 py-4 border-2 border-transparent focus-within:border-[#0b2b40] focus-within:shadow-lg">
                <FaGoogle
                  className="absolute left-3 top-1/2 transform -translate-y-1/2"
                  style={{
                    color: "#4285F4",
                    background:
                      "linear-gradient(45deg, #4285F4, #0b2b40, #FBBC05, #EA4335)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }} />
                <input
                  type="text"
                  placeholder="Ihr Unternehmensname"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  className="w-full text-[18px] outline-none pl-4 placeholder:text-black/60"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
              </div>

              {/* BUTTON */}

              <button
                onClick={handleSearch}
                disabled={loading}
                className="w-full py-3 bg-[#0b2b40] text-white font-semibold rounded-full hover:opacity-90 transition flex gap-8 items-center justify-between px-4 disabled:opacity-70"
              >
                <span>
                  {loading ? "Bitte warten..." : "Negative Bewertungen auswählen"}
                </span>
                <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
                  <HiArrowRight className="text-lg transform -rotate-24" />
                </span>
              </button>

              <p className="text-center text-black/60 text-[14px]">
                Zahlung nur bei Erfolg

              </p>

            </div>
          </div>


          <div className="h-[1px] bg-black/10"></div>

          {/* POLICY TEXT */}
          <div className="text-center flex flex-col gap-2">


            <p className="text-sm text-[#505064]">
              Mit dem Absenden dieses Formulars bestätigen Sie, die Datenschutzerklärung gelesen <br /> zu haben und ihr zuzustimmen.
            </p>
          </div>

        </div>
      </div>





    </section>
  );
};

const StepCircle = ({ number, text, active }) => (
  <div className="flex flex-col items-center gap-3 min-w-[90px] text-center">
    <div
      className={`w-[60px] h-[60px] flex items-center justify-center rounded-full text-white text-[24px] font-semibold 
        ${active ? "bg-[#0b2b40]" : "bg-[#0b2b40]/30"}`}
    >
      {number}
    </div>
    <p className={`text-[16px] font-medium ${active ? "text-[#0b2b40]" : "text-[#0b2b40]/40"}`}>
      {text}
    </p>
  </div>
);

const StepLine = ({ active, mobile }) => (
  <div
    className={`rounded-full 
      ${mobile ? "w-[35px] h-[4px]" : "w-[130px] h-[4px]"} 
      ${active
        ? "bg-gradient-to-r from-[#0b2b40] to-white"
        : "bg-gradient-to-r from-[#0b2b40]/30 to-white/30"
      }`}
  ></div>
);

export default HowRemove;
